module.exports = __webpack_public_path__ + "img/百香果6.e4ab20cd.png";